
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Talent Exploration</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm itoolovemynation section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>I Too Love <span > My Nation</span></h2>
            <p>An event of patriotism <br>
                14th September 2019
            </p>
        </div>
        <div class="row text-justify">

            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>I TOO LOVE MY NATION</h4>
                    <h6>On the occasion of Independence Day - 15<sup>th</sup> August 2019</h6>
                </div>
                <p>
                    Institutes of Raisoni group organized some competitions and Activities for the students of
                    respective Institutes

                    The first round of these competitions were held in respective Institutes on the occasion of
                    Independence Day

                    Winners of Respective Institutes later had an Inter RGI competition - Final Round in Nagpur on 14th
                    Sept 2019

                    The theme of all the competitions was Patriotism and subjects related to Nation, Personalities of
                    the Nation, Freedom Fighters, Issues of the Nation, and Events of the Nation etc...
                </p>
            </div>


            <div class="col-md-4">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lovemynation.jpg"
                        alt="GHRSCF" class="w-100">

                </div>
                <a href="result" class="cmn-button text-center"><span>
                    View Results</span>
                </a>
            </div>
        </div>
        <div class="gall-ery">

        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title gall-sys shadow-text-sm">
                    <h4>PHOTOS</h4>
                </div>
            </div>
            <div class="col-md-4 text-end">
                <a href="photogallery" class="cmn-button"><span>
                        View More</span>
                </a>
            </div>
        </div>

        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/in_6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>

            </ul>
        </div>
        </div>
    </div>

</section>
